const x = {
  pixelwidth: 300,
  header: "Wasserstofftankstelle",
  navigator: {
    noun: {
      singular: "Wasserstofftankstelle",
      plural: "Wasserstofftankstellen",
    },
  },
  noCurrentFeatureTitle: "Keine Wasserstofftankstelle gefunden",
  noCurrentFeatureContent:
    "Zurück zur einzigen Wasserstofftankstelle in Wuppertal mit dem untenstehenden Link.",
};
export default x;
